/* import __COLOCATED_TEMPLATE__ from './vertical-divider.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();